import client from '@/api/client'

export const requestPasswordlessLogin = ({
  email,
  redirectTo,
  promoCode,
}: {
  email: string
  redirectTo: string
  promoCode?: string
}) => {
  return client.POST('/auth/passwordless/login', {
    body: { email, redirectTo, ...(promoCode ? { promoCode } : {}) },
    // Endpoint returns 200 with an empty body — parsing as JSON would throw.
    parseAs: 'text',
  })
}

export const authRefresh = (refresh_token: string) => {
  return client.POST('/auth/refresh', { body: { refresh_token } })
}
